import { isValid, parse, parseISO } from 'date-fns';
import { MRT_ColumnDef } from 'material-react-table';

export const populateFavorite = (operations: any[], favorites: any[]) => {
  return operations.map((operation) => {
    const favorite = favorites.find(
      (favorite) => favorite.operation.hashId === operation.hashId,
    );
    return {
      ...operation,
      favorite,
    };
  });
};

export function parseDateValue(value: unknown): Date | null {
  if (!value) return null;

  const dateValue = String(value).trim();
  const parsedDate = /^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)
    ? parse(dateValue, 'dd/MM/yyyy', new Date())
    : parseISO(dateValue);

  return isValid(parsedDate) ? parsedDate : null;
}

export function getLatestUpdatedAt(
  operations: { updatedAt?: string | Date }[],
): string | undefined {
  return operations.reduce<string | undefined>((latest, operation) => {
    const current = String(operation.updatedAt ?? '');
    if (!current) return latest;
    if (!latest) return current;
    return current > latest ? current : latest;
  }, undefined);
}

export function buildDefaultColumn(
  initialColumn: MRT_ColumnDef<any>,
): MRT_ColumnDef<any> {
  switch (initialColumn.meta) {
    case 'boolean':
      return {
        ...initialColumn,
        accessorFn: (row) => Boolean(row[String(initialColumn.accessorKey)]),
      };
    case 'datetime':
    case 'date':
      return {
        ...initialColumn,
        muiFilterDatePickerProps: { disableOpenPicker: true },
        filterVariant: 'date',
        accessorFn: (row) =>
          parseDateValue(row[String(initialColumn.accessorKey)]),
        Cell: ({ cell }) => cell.getValue<Date>()?.toLocaleDateString() || '',
      };
    case 'biginteger':
    case 'integer':
      return {
        ...initialColumn,
        accessorFn: (row) =>
          Number(row[String(initialColumn.accessorKey)] ?? 0),
      };
    case 'float':
    case 'decimal':
      return {
        ...initialColumn,
        accessorFn: (row) =>
          parseFloat(
            Number(row[String(initialColumn.accessorKey)] ?? 0).toFixed(2),
          ),
        Cell: ({ cell }) =>
          cell.getValue<number>()?.toLocaleString?.('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) || '',
      };
    default:
      return {
        ...initialColumn,
        accessorFn: (row) => row[String(initialColumn.accessorKey)] ?? '',
      };
  }
}
